import media from './media'

const image =
{
    ...media,
    remove :
    {
        agree       : 'Supprimer' ,
        description : 'Souhaitez-vous supprimer cette image ?' ,
        disagree    : 'Annuler' ,
        loading     : 'Suppression en cours...' ,
        title       : 'Supprimer l\'image ?',
        useID       : false
    },
    snacks   :
    {
        failed  : 'Impossible d\'ajouter une image',
        removed : 'Image supprimée',
        success : 'Image ajoutée avec succès',
    },
    title : 'Image'
};

export default image ;